import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { encodeSearchParams, getJson } from '@hcr/api/shared'

import { UserExistenceDtoSchema, type ProblemDetailsDto, type UserExistenceDto } from '../../dtos'
import type { AuthorizedRequestParams } from '../../models'
import { createAuthorizationHeader } from '../../utils'

interface UserExistenceEmailQueryParams {
  email?: string
}

export const createUserExistenceQueryKey = (params: UserExistenceEmailQueryParams) => [
  'consumer',
  'b2c-user-existence',
  params,
]

export const createUserExistenceQuery =
  (baseUrl: string) =>
  <Data = UserExistenceDto>(
    { idToken, ...params }: AuthorizedRequestParams & UserExistenceEmailQueryParams,
    options?: Partial<UseQueryOptions<UserExistenceDto, ProblemDetailsDto, Data>>
  ) =>
    useQuery<UserExistenceDto, ProblemDetailsDto, Data>({
      ...options,
      queryKey: createUserExistenceQueryKey(params),
      queryFn: () =>
        getJson({
          headers: createAuthorizationHeader(idToken),
          schema: UserExistenceDtoSchema,
          url: `${baseUrl}/b2c-user-existence${encodeSearchParams({ email: params.email })}`,
        }),
    })
